import I18n from "packs/i18n.js.erb"
const feather = require("feather-icons")
require('data-confirm-modal')
import bsCustomFileInput from 'bs-custom-file-input'
import selectize from 'selectize'
import "bootstrap-daterangepicker"

document.addEventListener("turbolinks:load", () => {
  feather.replace()
  $('[data-toggle="tooltip"]').tooltip()
  dataConfirmModal.setDefaults({
    cancelClass: 'btn-light',
    commitClass: 'btn-primary',
    modalClass: 'modal-confirm'
  })
  bsCustomFileInput.init()
  $('.selectize').selectize({
    allowEmptyOption: true,
    highlight: false,
    maxItems: 1
  })
  $('.selectize-multiple').selectize({
    plugins: ['remove_button'],
    allowEmptyOption: true,
    highlight: false,
  })
  $('.datepicker').daterangepicker({
    singleDatePicker: true,
    locale: {
      format: I18n.t("daterangepicker.format"),
      applyLabel: I18n.t("actions.apply"),
      cancelLabel: I18n.t("actions.cancel"),
      daysOfWeek: I18n.t("date.abbr_day_names"),
      monthNames: I18n.t("date.month_names").slice(1)
    },
    cancelClass: "btn-light"
  })
  $('.datepicker-blank').daterangepicker({
    autoUpdateInput: false,
    singleDatePicker: true,
    locale: {
      format: I18n.t("daterangepicker.format"),
      applyLabel: I18n.t("actions.apply"),
      cancelLabel: I18n.t("actions.clear"),
      daysOfWeek: I18n.t("date.abbr_day_names"),
      monthNames: I18n.t("date.month_names").slice(1)
    },
    cancelClass: "btn-light"
  })
  $('.datepicker-blank').on('apply.daterangepicker', (event, picker) => {
    $(event.target).val(picker.startDate.format(I18n.t("daterangepicker.format")))
  })
  $('.datepicker-blank').on('cancel.daterangepicker', (event, picker) => {
    $(event.target).val('')
  })
  $('.timepicker').daterangepicker({
    singleDatePicker: true,
    timePicker: true,
    timePickerIncrement: 1,
    locale: {
      format: "hh:mm A",
      applyLabel: I18n.t("actions.apply"),
      cancelLabel: I18n.t("actions.cancel")
    },
    cancelClass: "btn-light"
  }).on('show.daterangepicker', (ev, picker) => {
    picker.container.find(".calendar-table").hide()
  })
});
